"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleAnalysisType = void 0;
var SampleAnalysisType;
(function (SampleAnalysisType) {
    SampleAnalysisType[SampleAnalysisType["TRG"] = 0] = "TRG";
})(SampleAnalysisType = exports.SampleAnalysisType || (exports.SampleAnalysisType = {}));
//# sourceMappingURL=SampleAnalysisType.js.map